import { makeStyles, tokens } from '@fluentui/react-components';

const WORKSPACE_MENU_WIDTH = '225px';

export const useStyles = makeStyles({
  trigger: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    height: '32px',
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    borderTopWidth: '1px',
    borderRightWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderTopColor: tokens.colorNeutralStrokeOnBrand2,
    borderRightColor: tokens.colorNeutralStrokeOnBrand2,
    borderBottomColor: tokens.colorNeutralStrokeOnBrand2,
    borderLeftColor: tokens.colorNeutralStrokeOnBrand2,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorTransparentBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    ':hover': {
      backgroundColor: tokens.colorSubtleBackgroundLightAlphaHover,
      borderTopColor: tokens.colorNeutralStrokeOnBrand2Hover,
      borderRightColor: tokens.colorNeutralStrokeOnBrand2Hover,
      borderBottomColor: tokens.colorNeutralStrokeOnBrand2Hover,
      borderLeftColor: tokens.colorNeutralStrokeOnBrand2Hover,
    },
  },
  triggerLabel: {
    maxWidth: '180px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  triggerPlaceholder: {
    opacity: '0.8',
    fontWeight: tokens.fontWeightRegular,
  },
  menuPopover: {
    width: WORKSPACE_MENU_WIDTH,
  },
  menuHeader: {
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
  },
  search: {
    display: 'flex',
    minWidth: 0,
    marginTop: tokens.spacingVerticalXS,
    marginBottom: tokens.spacingVerticalS,
    marginLeft: tokens.spacingHorizontalXS,
    marginRight: tokens.spacingHorizontalXS,
  },
  searchInput: {
    '::-webkit-search-cancel-button': {
      display: 'none',
    },
  },
  menuScroll: {
    maxHeight: 'min(50vh, 320px)',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  menuItemInner: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    alignItems: 'flex-start',
  },
  menuItemName: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
  },
  menuItemNameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
  visibilityIcon: {
    width: tokens.fontSizeBase300,
    height: tokens.fontSizeBase300,
    fontSize: tokens.fontSizeBase300,
    flexShrink: 0,
  },
  visibilityTooltipTarget: {
    display: 'inline-flex',
    alignItems: 'center',
    paddingTop: tokens.spacingVerticalXXS,
    paddingRight: tokens.spacingHorizontalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingLeft: tokens.spacingHorizontalXXS,
  },
  menuItemMeta: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
    fontFamily: 'SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace',
  },
});
